import { CATEGORY_STATE } from '@sanlam-glacier/app-common/components';
import { StepperCategoryState } from 'types/stepper/proposal-stepper-type';

export const mapStepperStateToCX = (state: StepperCategoryState): CATEGORY_STATE => {
  switch (state) {
    case StepperCategoryState.DEFAULT:
      return CATEGORY_STATE.DEFAULT;
    case StepperCategoryState.COMPLETED:
      return CATEGORY_STATE.COMPLETED;
    case StepperCategoryState.ERROR:
      return CATEGORY_STATE.ERROR;
    case StepperCategoryState.SELECTED:
      return CATEGORY_STATE.SELECTED;
    case StepperCategoryState.WARNING:
      return CATEGORY_STATE.WARNING;
    default:
      return CATEGORY_STATE.DEFAULT;
  }
};
